import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const ImageSmall = ({ image }) => {
  const base =
    'relative w-full lg:max-w-[400px] aspect-[3/4] mt-smallMobile lg:mt-[68px]'

  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default ImageSmall
